import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { fontSize } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';

type Option = { label: string | number; value: string | number | boolean } | undefined | null;

type CustomProps = StyledSystemProps & {
  options: Array<Option>;
  name: string;
  autoFocus?: boolean;
  'aria-label'?: string;
  label?: string;
  color?: string;
  inputValue?: string;
  isMulti?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  isSearchable?: boolean;
  menuIsOpen?: boolean;
  placeholder?: string;
  onChange?: (option: any) => void;
  onBlur?: () => void;
  value?: Option;
  setSearchName?: (data: string) => void | undefined;
  scrollHandler?: () => void;
  loading?: boolean;
};

const StyledSelect = styled(Select)`
  ${fontSize};
  & .react-select__control {
    min-height: 40px;
  }
  & .react-select__menu .react-select__menu-list .react-select__option--is-selected {
    background-color: ${themeGet('colors.putty', '#EEE')};
  }
  & .react-select__control--is-focused {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    box-shadow: none;
  }
  & .react-select__control:hover {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    box-shadow: none;
  }
  & .react-select__menu {
    color: hsl(0, 0%, 20%);
  }
`;

const StyledFormSelect: React.FC<CustomProps> = props => {
  return (
    <Box {...props}>
      {props.label && <Label htmlFor={props.name}>{props.label}</Label>}
      <StyledSelect
        aria-label={props['aria-label']}
        autoFocus={props.autoFocus}
        isDisabled={props.isDisabled}
        placeholder={props.placeholder}
        isClearable={props.isClearable}
        isMulti={props.isMulti}
        isSearchable={props.isSearchable}
        classNamePrefix="react-select"
        menuIsOpen={props.menuIsOpen}
        name={props.name}
        options={props.options}
        onBlur={props.onBlur}
        onChange={props.onChange}
        isLoading={props.loading}
        onInputChange={(data: string) => props.setSearchName && props.setSearchName(data)}
        onMenuScrollToBottom={props.scrollHandler}
        value={props.value}
        inputValue={props.inputValue}
        loadingMessage={() => 'loading...'}
        noOptionsMessage={() => 'no options'}
        // menuPortalTarget={document.body}
        // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </Box>
  );
};

export default StyledFormSelect;

StyledFormSelect.defaultProps = {
  options: [],
  mb: 3,
  flex: 1,
  fontSize: 1,
  minWidth: '150px',
  width: '100%',
};
